import { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

export function RetiredFeaturePage({ destination, destinationLabel }: { destination: string; destinationLabel: string }) {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const navigate = useNavigate();
  useEffect(() => { titleRef.current?.focus(); }, []);
  return <div className="page narrow"><section className="empty-state retired-feature"><h1 ref={titleRef} tabIndex={-1}>This feature is no longer available.</h1><p>Your existing Tasks and Projects were not changed.</p><div className="button-group"><Link className="button primary" to={destination}>{destinationLabel}</Link><button className="button" onClick={() => navigate(-1)}>Back</button></div></section></div>;
}
